"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBookmarkStarCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zM15.531 6c.186 0 .34.131.376.306l.007.077v11.233a.383.383 0 01-.572.333l-.06-.042-3.325-2.85-3.325 2.85a.384.384 0 01-.613-.168l-.016-.07L8 17.616V6.383c0-.185.131-.34.306-.375L8.383 6h7.148zm-3.7 2.126l-.451 1.04a.119.119 0 01-.074.055l-1.124.105c-.178.016-.242.193-.117.32l.849.864c.018.018.03.068.023.091l-.33 1.166c-.05.183.11.299.267.192l1.092-.747c.015-.01.053-.01.068 0l1.092.747c.157.107.318-.009.266-.192l-.33-1.165a.122.122 0 01.024-.092l.849-.864c.125-.127.06-.303-.117-.32l-1.124-.105a.119.119 0 01-.074-.054l-.452-1.04c-.072-.169-.264-.169-.337-.001z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgBookmarkStarCircle;
exports.default = _default;